<template>
  <v-row no-gutters>
    <v-col cols="12">
      <card-title-row
        v-if="computedInputs?.length"
        class="pb-5"
        is-subtitle
        translation-path="dialog.userSettings.keyBindings.title"
        :has-icon-column="false"
        :has-buttons="false"
      >
        <template #subtitle>
          <italic-subheader translation-path="dialog.userSettings.keyBindings.subtitle" class="text-left">
            <template>
              <i18n path="dialog.userSettings.keyBindings.subtitle">
                <template #newline> <br /> </template>
              </i18n>
            </template>
          </italic-subheader>
        </template>
      </card-title-row>
      <sidebar-form is-editing-on :has-icon-column="false" :inputs="computedInputs" :value="{}">
        <template v-for="(input, idx) of computedInputs" #[`${input.name}`]="data">
          <v-row no-gutters :key="idx">
            <v-col cols="12">
              <data-input v-bind="data" :value="value[idx]['keyBind']" @input="onInput(idx, $event)" />
            </v-col>
          </v-row>
        </template>
      </sidebar-form>
    </v-col>
  </v-row>
</template>
<script>
import CardTitleRow from '@/components/CardTitleRow';
import ItalicSubheader from '@/components/ItalicSubheader';
import SidebarForm from '@/components/SidebarForm';
import DataInput from '@/components/DataInput';

export default {
  name: 'KeyBindings',
  components: { CardTitleRow, DataInput, ItalicSubheader, SidebarForm },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    computedInputs() {
      return JSON.parse(JSON.stringify(this.value)).map(keyBinding => {
        return {
          name: keyBinding.verboseName,
          straightTitle: keyBinding.verboseName,
          dataType: {
            name: 'keybind',
          },
          nameCols: '6',
          cols: '6',
          justifyClass: 'start',
          clearable: true,
        };
      });
    },
  },
  methods: {
    onInput(idx, value) {
      this.$set(this.value[idx], 'keyBind', value);
      this.$emit('input', this.value);
    },
  },
};
</script>
